import React from 'react';

function MetricValue({ metric, text, showLabel }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', gap: '0.277778vh', minWidth: 0,
      padding: '0.277778vh 0.555556vh', borderRadius: '0.462963vh', background: metric.bg,
    }}>
      {showLabel && <span title={text(metric.l)} style={{
        fontSize: '1.018519vh', color: '#b8c1ce', fontWeight: metric.fw,
        whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
      }}>{text(metric.l)}</span>}
      <span style={{ font: "600 1.203704vh 'IBM Plex Mono',monospace", color: metric.c, whiteSpace: 'nowrap' }}>
        {text(metric.v)}
      </span>
      <div style={{ height: '0.277778vh', borderRadius: '0.185185vh', background: '#1c2636', display: 'flex' }}>
        <div style={{ width: metric.w, background: metric.c, borderRadius: '0.185185vh' }} />
      </div>
    </div>
  );
}

export default function VersusTooltip({ tip, text }) {
  const shared = !!tip.groups;
  return (
    <div role="tooltip" style={{
      width: '100%', height: '100%', display: 'grid',
      gridTemplateColumns: (shared ? 'minmax(0,1.7fr)' : 'auto') + ' repeat(' + tip.rows.length + ',minmax(0,1fr))',
      gap: shared ? '0.37037vh 0.555556vh' : '1.296296vh', alignItems: 'center',
      padding: '0.740741vh 1.296296vh', boxSizing: 'border-box',
      background: 'rgba(6,14,28,0.9)', border: '0.092593vh solid rgba(46,179,238,0.28)',
      borderTop: '0.185185vh solid ' + tip.c, borderRadius: '0.740741vh', pointerEvents: 'none',
    }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.185185vh', minWidth: 0 }}>
        <span style={{ font: "600 " + (shared ? '1.203704vh' : '1.388889vh') + " 'IBM Plex Mono',monospace", color: tip.c, whiteSpace: 'nowrap' }}>
          {text(tip.title)}
        </span>
        <span style={{ fontSize: '1.018519vh', color: '#8793a6', whiteSpace: 'nowrap' }}>{text(tip.sub)}</span>
      </div>
      {tip.rows.map((metric, index) => shared ? (
        <span key={index} title={text(metric.l)} style={{
          padding: '0 0.555556vh', fontSize: '1.018519vh', color: metric.c,
          whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
        }}>{text(metric.l)}</span>
      ) : <MetricValue key={index} metric={metric} text={text} showLabel />)}
      {shared && tip.groups.map((group, index) => (
        <React.Fragment key={index}>
          <span style={{
            font: "600 1.203704vh 'IBM Plex Mono',monospace", color: group.c,
            whiteSpace: 'nowrap', background: group.active ? 'rgba(46,179,238,0.1)' : 'transparent',
            padding: '0.277778vh 0', borderRadius: '0.462963vh',
          }}>{text(group.title)}</span>
          {group.rows.map((metric, metricIndex) => (
            <MetricValue key={metricIndex} metric={metric} text={text} showLabel={false} />
          ))}
        </React.Fragment>
      ))}
    </div>
  );
}
